<template lang="pug">
    #app
        transition(name="state-fade" mode="out-in")
            SplashScreen(v-if="isLoading" key="123")
        transition(name="state-fade" mode="out-in")
            template(v-if="!isLoading")
                transition(name="state-fade" mode="out-in")
                    Layout(v-if="$store.getters.isAuth")
                    Auth(v-else)
        notifications(position="top center")
</template>

<script>
import "bulma/css/bulma.css";
import SplashScreen from "@/views/SplashScreen";
import Layout from "@/components/Layout";
import Auth from "@/components/Auth";

export default {
  name: "App",
  components: {
    SplashScreen,
    Layout,
    Auth
  },
  data: () => ({
    isLoading: true
  }),
  methods: {
    session() {
      return this.$store
        .dispatch("session")
        .then(res => {
          if (res) this.checkSession();
        })
        .catch(e => {
          this.$notify({
            type: "error",
            title: "Init session error",
            text: e
          });
        })
        .finally(() => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
    },
    users() {
      return this.$store
        .dispatch("getUserList")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Get user list error",
            text
          });
        })
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "users",
            status: false
          });
        });
    },
    subscriptions() {
      return this.$store
        .dispatch("getSubscription")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Error",
            text
          });
        })
        .finally(() => {
          this.$store.dispatch("getSubscriptionHistory").catch(text =>
            this.$notify({
              type: "error",
              title: "Error",
              text
            })
          );
          this.$store.commit("isLoading", {
            key: "subscriptions",
            status: false
          });
        });
    },
    crawlerSettings() {
      return this.$store
        .dispatch("getCrawlerSettings")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Error",
            text
          });
        })
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "crawlerSettings",
            status: false
          });
        });
    },
    appSettings() {
      return this.$store
        .dispatch("getAppSettings")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Error",
            text
          });
        })
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "appSettings",
            status: false
          });
        });
    },
    companies() {
      return this.$store
        .dispatch("getCompanies")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Get company list error",
            text
          });
        })
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "company",
            status: false
          });
        });
    }
  },
  watch: {
    '$store.getters.isAuth'(newVal) {
      if (newVal) {
        this.users();
        this.subscriptions();
        this.crawlerSettings();
        this.appSettings();
        this.companies();
      }
    }
  },
  async mounted() {
    this.session();

  }
};
</script>

<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  background-color: #3a4750;
  color: $defaultColor;
  overflow: hidden;
}

#app {
  width: 100%;
  height: 100%;
  overflow: hidden;

  #nprogress {
    .bar {
      background: $brandColor;
    }

    .peg {
      box-shadow: 0 0 10px #0883ec, 0 0 5px #0883ec !important;
    }
  }
}

.state-fade-enter-active,
.state-fade-leave-active {
  transition: opacity 1s;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-to,
.state-fade-enter,
.state-fade-leave-to {
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}
</style>
